module.exports = __webpack_public_path__ + "static/media/rentalcarProject.a98e6ed1.webp";